import jwtDecode from "jwt-decode";
import Vue from "vue";
const tokenData = () => {
  const hasToken = Vue.$cookies.isKey("_token");
  if (hasToken) {
    const token = Vue.$cookies.get("_token");
    const decodedToken = jwtDecode(token);
    const currentTime = Math.ceil(new Date().getTime() / 1000);
    const remaining = decodedToken.exp ? decodedToken.exp - currentTime : 0;
    return { hasToken, token, decodedToken, currentTime, remaining };
  }
  return { hasToken };
};

export default async (to, from, next) => {
  let token = tokenData();
  if (token.hasToken) {
    if (
      to.matched.some(
        (record) =>
          record.meta.isAdmin &&
          token.decodedToken &&
          !token.decodedToken.is_super_admin
      )
    ) {
      return next("/");
    }
  }
  next();
};
